import { useEffect, useState, type ReactNode } from "react";
import { Sidebar } from "./Sidebar";

export function Layout({ children }: { readonly children: ReactNode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (!sidebarOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setSidebarOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [sidebarOpen]);

  return (
    <div className="docs-layout">
      <a className="docs-skip-link" href="#docs-main">
        Skip to content
      </a>
      <button
        type="button"
        className="docs-nav-toggle"
        onClick={() => setSidebarOpen((open) => !open)}
        aria-expanded={sidebarOpen}
        aria-controls="docs-sidebar"
        aria-label={sidebarOpen ? "Close navigation" : "Open navigation"}
      >
        <span className="docs-nav-toggle__bar" />
        <span className="docs-nav-toggle__bar" />
        <span className="docs-nav-toggle__bar" />
      </button>
      {sidebarOpen && (
        <button
          type="button"
          className="docs-sidebar-backdrop"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
          tabIndex={-1}
        />
      )}
      <Sidebar
        open={sidebarOpen}
        onNavigate={() => setSidebarOpen(false)}
      />
      <main id="docs-main" className="docs-main">
        {children}
      </main>
    </div>
  );
}
